define('views/modules/template/edit/calendar/calendar-component/template-calendar-day-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    'services/i18n',
    // Views
    'views/modules/calendar/calendar/calendar-component/item/calendar-day-item',
    'views/modules/template/edit/calendar/calendar-component/template-item-delete-modal',
    'views/parts/menu/menu-context',
], function(
    // libs
    _, Backbone, Mustache, moment, U,
    i18n,
    // views
    VCalendarDayItem,
    VTemplateCalendarItemDeleteModal,
    VMenuContext
) {

    var VTemplateCalendarDayItem = VCalendarDayItem.extend({
        render: function() {
            var model = this.model,
                html = Mustache.render(this.template, Mustache.getContext({
                    feedback: false,
                    title: model.getDisplayTitle(),
                    type: model.get('type'),
                    weekNumber: this.getWeekNumber(),
                    description: model.getDescription(),
                    summary: this.options.summary,
                }));

            this.$el.empty().append(html);

            this.generateZones();

            return this;
        },

        closeDetails: function() {
            if (this.$el.hasClass('active')) {
                this.setActive(false);
                this.model.trigger('close:details');
                return true;
            }
            return false;
        },

        showMenuOptions: function(e) {
            e.preventDefault();
            if (!this.vMenuOptions) {
                var menuItems = new Backbone.Collection([
                    { caption: "Edit", icon: "sl-icon-pencil", callback: this.onEditItem },
                    { caption: "Duplicate", icon: "sl-icon-docs", callback: this.onDuplicateAction },
                    { caption: "Delete", icon: "sl-icon-trash", callback: this.onDeleteAction }
                ]);

                if (this.model.get('type') === "animated") {
                    menuItems.add({ caption: "calendar:Download", icon: "sl-icon-printer", callback: this.onPrintAction });
                }

                this.vMenuOptions = new VMenuContext({
                    context: this,
                    onClick: this.onActionClick,
                    collection: menuItems
                });

                this.assign(this.vMenuOptions, this.zone.$menu);
            }
            this.vMenuOptions.toggle();
        },

        triggerClick: function() {
            var model = this.model;
            model.trigger('item:click', model.clone());
            model.trigger('day:click');
            this.setActive(true);
        },

        setActive: function(val) {
            this.$el.toggleClass("active", val);
            return this;
        },

        onDeleteAction: function(e) {
            e.preventDefault();
            // TODO add a button for "all" the items of a session.
            // Bootbox.confirm({
            //     title: i18n.t('Delete an activity'),
            //     message: i18n.t('messages:message-delete-activity'),
            //     callback: this.onDelete,
            //     context: this,
            // });
            var view = this.view,
                modal = view.destroy || (view.destroy = new VTemplateCalendarItemDeleteModal());

            modal.setModel(this.model).render();
        },

        ////////////
        // events //
        ////////////

        onClick: function(e) {
            var target = e.target,
                zone = this.zone;
            if (target === zone.$toggle.get(0) || this.closeDetails()) {
                e.preventDefault();
            } else {
                this.triggerClick();
            }
        },

        onEditItem: function() {
            this.triggerClick();
        },

        onMove: function(e, data) {
            var model = this.model;
            model.trigger("item:remove", model);
            data.collection.add(model, { at: data.position, silent: true, sync: false });
            model.trigger("item:move");
        },

        onDelete: function(result) {
            if (result) {
                this.model.trigger('item:destroy', this.model);
            }
        },

        onRoute: _.noop

    });

    return VTemplateCalendarDayItem;
});

